import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-make-payment',
  templateUrl: './make-payment.component.html',
  styleUrls: ['./make-payment.component.scss']
})
export class MakePaymentComponent implements OnInit {
  constructor(private router: Router) { }
  ngOnInit(): void {
  }

  goToAddBalance() {
    console.log('Method calling....')
    this.router.navigate(['add-balance-wallet'])
  }

}
